// takes a product and returns true if any of the variants have the
// company_owned_dealer_variant metafield set to true
// this functionality is currently only used in Invisible Fence

import type {
  SanityShopifyProduct,
  SanityProductVariant,
} from '@repo/models/gatsby-graphql-types';

interface CustomSanityShopifyProductVariant extends SanityProductVariant {
  metafields?: {
    key: string;
    value: string;
  }[];
}

interface CustomSanityShopifyProduct extends SanityShopifyProduct {
  variants: CustomSanityShopifyProductVariant[];
}

function hasCompanyOwnedDealerVariants(product: CustomSanityShopifyProduct) {
  if (!product) return false;

  return product.variants?.some(variant => {
    const metafield = variant.metafields?.find(
      variantMetafield =>
        variantMetafield.key === 'company_owned_dealer_variant'
    );
    return metafield && metafield.value === 'true';
  });
}

export default hasCompanyOwnedDealerVariants;
